"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SwiftButton", {
  enumerable: true,
  get: function get() {
    return _swiftButton.default;
  }
});
Object.defineProperty(exports, "SwiftForm", {
  enumerable: true,
  get: function get() {
    return _swiftForm.default;
  }
});
Object.defineProperty(exports, "SwiftIcon", {
  enumerable: true,
  get: function get() {
    return _swiftIcon.default;
  }
});
Object.defineProperty(exports, "SwiftMomentDateFormats", {
  enumerable: true,
  get: function get() {
    return _time.SwiftMomentDateFormats;
  }
});
Object.defineProperty(exports, "SwiftProvider", {
  enumerable: true,
  get: function get() {
    return _providers.default;
  }
});
Object.defineProperty(exports, "SwiftSubtitle", {
  enumerable: true,
  get: function get() {
    return _swiftSubtitle.default;
  }
});
Object.defineProperty(exports, "SwiftTable", {
  enumerable: true,
  get: function get() {
    return _swiftTable.default;
  }
});
Object.defineProperty(exports, "SwiftTabs", {
  enumerable: true,
  get: function get() {
    return _tabs.SwiftTabs;
  }
});
Object.defineProperty(exports, "SwiftTheme", {
  enumerable: true,
  get: function get() {
    return _providers.SwiftTheme;
  }
});
Object.defineProperty(exports, "SwiftTitle", {
  enumerable: true,
  get: function get() {
    return _swiftTitle.default;
  }
});
var _swiftForm = _interopRequireDefault(require("./components/forms/swift-form"));
var _swiftSubtitle = _interopRequireDefault(require("./components/inputs/swift-subtitle"));
var _swiftTitle = _interopRequireDefault(require("./components/inputs/swift-title"));
var _swiftButton = _interopRequireDefault(require("./components/buttons/swift-button"));
var _swiftTable = _interopRequireDefault(require("./components/tables/swift-table"));
var _swiftIcon = _interopRequireDefault(require("./components/icons/swift-icon"));
var _tabs = require("./components/tabs");
var _time = require("./components/time");
var _providers = _interopRequireWildcard(require("./components/providers"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }